import { render } from "./GuiClientDocumentTypeSelect.vue?vue&type=template&id=a8f898ee"
import script from "./GuiClientDocumentTypeSelect.vue?vue&type=script&lang=js"
export * from "./GuiClientDocumentTypeSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__